import type { DateTimePickerProps as LaunchpadDateTimePickerProps } from '@gonfalon/ui/DateTimePicker';
import { DateTimePicker as LaunchpadDateTimePicker } from '@gonfalon/ui/DateTimePicker';

import { useFieldContext } from '../../contexts';

import { FormFieldError } from './FormFieldError';

type DateTimePickerProps = Omit<LaunchpadDateTimePickerProps, 'onChange' | 'name'>;
export function DateTimePicker(props: DateTimePickerProps) {
  const field = useFieldContext<number | null | undefined>();
  const { name } = field;
  const isInvalid = field.state.meta.isTouched && field.state.meta.errors.length > 0;
  return (
    <>
      <LaunchpadDateTimePicker
        name={name}
        onChange={field.handleChange}
        {...props}
        datepickerProps={{ ...props.datepickerProps, isInvalid }}
        timepickerProps={{ ...props.timepickerProps, isInvalid }}
      />
      <FormFieldError meta={field.state.meta} />
    </>
  );
}
